import FormulaError from './FormulaError.js';
import { parse, collectReferences, FUNCTIONS } from './parser.js';
import evaluate from './evaluate.js';

const cache = new Map();
const CACHE_LIMIT = 200;

/*
  Compiles a chart formula once and returns an evaluator for data rows.
  Formulas never go through eval(); only the operators and FUNCTIONS in parser.js are supported.

  const { evaluate, references, error } = compileFormula('IF([[a]] < 10, 10, 20)');
  evaluate({ a: 5 }); // => 10

  When the formula is invalid, `error` is a FormulaError and `evaluate` always returns null.
*/
export const compileFormula = (formula) => {
  const key = formula ?? '';
  if (cache.has(key)) return cache.get(key);

  let compiled;
  try {
    const ast = parse(key);
    compiled = {
      error: null,
      references: [...collectReferences(ast)],
      evaluate: (row) => evaluate(ast, row),
    };
  } catch (e) {
    if (!(e instanceof FormulaError)) throw e;
    compiled = { error: e, references: [], evaluate: () => null };
  }

  if (cache.size >= CACHE_LIMIT) {
    cache.delete(cache.keys().next().value);
  }
  cache.set(key, compiled);
  return compiled;
};

export { FormulaError, FUNCTIONS };
